module.exports = __webpack_public_path__ + "img/invalid@3x.e2312f7f.png";